import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@material-ui/core";
import { Environment } from "../_generated";

export default function EnvironmentUpdateDialog(props: {
  open: boolean;
  environment?: Environment;
  onCancel: () => any;
  onConfirm: () => any;
}) {
  return (
    <Dialog open={props.open}>
      <DialogTitle>Update Environment: {props.environment?.name}</DialogTitle>
      <DialogContent>
        Infrastructure will be updated to the latest version. If you created new
        services, the needed infrastructure for them will be provisioned. If you
        deleted some services, their supporting infrastructure will be
        destroyed.
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={props.onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
